import useId from '../utils/useId';
import * as React from 'react';
export const cymbioSvg = React.forwardRef(function cymbioSvgInner(props, ref) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.96 27a11.813 11.813 0 0 1-9.773-5.184l-.523-.766 5.964-4.06.52.769a4.595 4.595 0 0 0 7.686-.103l1.56.992a6.442 6.442 0 0 1-10.204.878l-2.92 1.99a9.957 9.957 0 0 0 16.014-.855l1.544 1.018A11.788 11.788 0 0 1 15.959 27Z',
      fill: `url(#bi_cymbio__a_${id_0})`,
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm20.372 15.02-.52-.768a4.591 4.591 0 0 0-7.686.104l-1.56-.992a6.442 6.442 0 0 1 10.205-.878l2.932-1.99a9.957 9.957 0 0 0-16.014.853l-1.554-1.016a11.809 11.809 0 0 1 19.643-.137l.518.764-5.964 4.06Z',
      fill: `url(#bi_cymbio__b_${id_1})`,
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_cymbio__a_${id_0}`,
          x1: 5.664,
          y1: 21.995,
          x2: 25.825,
          y2: 21.995,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#E119B9',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#5C03EC',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_cymbio__b_${id_1}`,
          x1: 26.336,
          y1: 10.017,
          x2: 6.175,
          y2: 10.017,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#E119B9',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#5C03EC',
        }),
      ),
    ),
  );
});
cymbioSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cymbio = {
  category: 'brand',
  colorable: false,
  name: 'cymbio',
  svg: cymbioSvg,
};
